import { useOrdersListFilterFields } from 'pages/Orders/OrdersList/hooks/useOrdersListFilterFields';
import { FilterFields } from 'shared/mui/Filter/FilterFields/FilterFields';

export const OrderListFilter: React.FC = () => {
  const fields = useOrdersListFilterFields();

  return <FilterFields fields={fields} />;
};
